import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (response: any) => {
  const { content, page } = response.data
  const respData: any = []
  content.map((item: any) => {
    const txnItem = {
      ...item,
      id: item.transactionId,
      status: item?.status,
    }
    respData.push(txnItem)
  })
  return { data: respData, page }
}

const getSubscriptionDetailsTxnV3 = (req: any, tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.getSubscriptionTxnsHistoryV3,
    method: 'POST',
    cache: false,
    body: req,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { getSubscriptionDetailsTxnV3 }
